import React from 'react';
import MTransfer from '../PDF/Money Transfer Integration Test Cases.pdf'
const ExamplesComponent =() => {
 
    return (
      <div>
    <iframe
            style={{ width: "1500px", height: "666px" }}
            src={MTransfer}
            type='application/pdf'
            title='title'
          />
</div>
    )

}
export  default ExamplesComponent;
